export default __webpack_public_path__ + "static/media/laundry2-afterB-1024w.3e4688e0.webp";